module.exports = __webpack_public_path__ + "img/9788996373711.a80b3b89.jpg";